import { Children } from "./v1";

export type ChildrenV1Type = keyof typeof Children;
export type ChildrenType = ChildrenV1Type;
